import ViewerNavigation from './ViewerNavigation';

export default ViewerNavigation;
